import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e799a112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "desc"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Importante", -1))
const _hoisted_7 = { class: "remark" }
const _hoisted_8 = { class: "remark" }
const _hoisted_9 = { class: "remark" }
const _hoisted_10 = { class: "remark" }
const _hoisted_11 = { class: "remark" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "El tiempo estimado de realización es de 40 minutos. Asegúrate de disponer de espacio suficiente antes de comenzar la prueba.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "danger" }, "Una vez pulses sobre el botón de comenzar se te contará como un intento, aunque no entregues o finalices la prueba. No recargues ni abandones la página durante el examen, la cuenta será penalizada.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "danger" }, "Has consumido todos los intentos para esta evaluación. Si quieres volver a intentarlo, escríbenos un correo a soporte para que podamos evaluar tu caso. Puedes encontrar la dirección en el footer de la página.", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Debes registrarte o acceder con tu cuenta para realizar el examen de certificación.", -1))
const _hoisted_22 = [
  _hoisted_21
]

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import EvaluationService from '@/services/EvaluationService'
import CourseService from '@/services/CourseService'
import { useAuth } from '@/store/useAuth'

export default /*#__PURE__*/_defineComponent({
  __name: 'CertificationView',
  setup(__props) {

const router = useRoute()
const id = router.params.id
const evaluationService = new EvaluationService()
const courseService = new CourseService()
const loading = ref(true)
const evaluation = ref()
const tries = ref()
const course = ref()
const store = useAuth()
const noMoreTries = ref(false)

onMounted(async () => {
    loading.value = true
    evaluation.value = await evaluationService.getEvaluationInfo(id)
    course.value = await courseService.GetCourse(evaluation.value.course_id)
    if (store.token) {
        tries.value = await evaluationService.getUserTries(store.token, id)
        if (evaluation.value.max_tries <= tries.value) {
            noMoreTries.value = true
        }
    }
    loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(evaluation.value.name), 1),
            _createElementVNode("div", {
              innerHTML: evaluation.value.description,
              class: "desc"
            }, null, 8, _hoisted_3),
            _hoisted_4,
            (_unref(store).token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", null, [
                    _createTextVNode("En esta evaluación se te examinará del temario del curso: "),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(course.value.name), 1),
                    _createTextVNode(". Si aún no lo has realizado, te recomendamos darle un repaso antes de continuar.")
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode("Esta evaluación es de tipo test, y contiene un total de "),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(evaluation.value.number_of_questions), 1),
                    _createTextVNode(" preguntas que se generarán en el momento de comenzar la prueba. Deberás responder correctamente un mínimo de "),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(evaluation.value.questions_to_pass), 1),
                    _createTextVNode(" preguntas para aprobar.")
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode("Dispones de "),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(evaluation.value.max_tries), 1),
                    _createTextVNode(" intentos para obtener la certificación. Actualmente has consumido "),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(tries.value), 1),
                    _createTextVNode(" intentos.")
                  ]),
                  _hoisted_12,
                  _hoisted_13,
                  (!noMoreTries.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _hoisted_16,
                        _createVNode(_component_RouterLink, {
                          class: "button",
                          to: { name: 'evaluation', params: { id: _unref(id) } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ok, entendido. QUIERO COMENZAR MI EXAMEN DE CERTIFICACIÓN.")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
          ]))
    ]),
    _: 1
  }))
}
}

})